import React from "react";
import { IUserViewData, defaultUserData } from "../../models/user/UserViewData";
import userActions from "../../flux/actions/UserActions";
import userListStore from "../../flux/stores/user/ListStore";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Icon, Spinner } from "@abb/abb-common-ux-react";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import History from "../../utilities/History";

interface TableState{
  list:IUserViewData[],
}

export default class UserViewAll extends React.Component<IUserViewData,TableState> {
  _mount = false;
  private _moduleName = CONSTANTS.MODULE_USERS;
  
  state:TableState={
    list:[]
  }
  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    navigationHeaderActions.updateHeader({
      name: CONSTANTS.MODULE_USERS,
      action: CONSTANTS.VIEW_ALL,
      icon: ICONCONSTANTS.ABB_VIEW,
      goBackUrl: "",
      isGoBackWithData: false,
      goBackData: {},
      isDataChanged: false
    }).then();

    userActions.getAll().then();

    userListStore.on('change', (state) => {
      if (this._mount) {
        const data:any =  state.userDataList;
        this.setState({list: data});
      }
    });

  }

  goBack = () => {
    History.push(CONSTANTS.USER_INDEX_URL);
  };
  
 
  public render() {
    return (
      <Translation>
        {
          t =>
            <div className="page-scroll">
              <div className="app-container mt-4">
                <div className="container-box rounded-sm rounded-lg submit-header-fixed ml-1 viewall-page">
                <div>
                  <Icon
                    name="abb/caret-left"
                    sizeClass="large"
                    style={{ cursor: "pointer" }}
                    onClick={this.goBack}
                  />
                </div>
                <div className="viewall-page-title">
                  <span
                    className="title font-weight-bold mt-2 ml-1"
                    style={{ verticalAlign: "super" }}
                  >
                    {t(CONSTANTS.ALL_USERS)}
                  </span>
                </div>
              </div>
                <div className="ml-1">
                  <AbbTableComponent
                  authKey={CONSTANTS.AUTHKEY_USERS}
                    columns={[
                      {
                        dataField: "firstName",
                        text: t(CONSTANTS.LABEL_FIRST_NAME),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: '15%', textAlign: 'left', fontWeight: 'bold' };
                        }
                      },
                      {
                        dataField: "lastName",
                        text: t(CONSTANTS.LABEL_LAST_NAME),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: '10%', textAlign: 'left' };
                        }
                      },
                      {
                        dataField: "username",
                        text: t(CONSTANTS.LABEL_USERNAME),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: '10%', textAlign: 'left' };
                        }
                      },
                      {
                        dataField: "email",
                        text: t(CONSTANTS.LABEL_EMAIL),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: '10%', textAlign: 'left' };
                        }
                      },
                      {
                        dataField: "role.name",
                        text: t(CONSTANTS.LABEL_ROLE),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: '10%', textAlign: 'left' };
                        }
                      }
                    ]}
                    list={this.state.list}
                    select={false}
                    isFixedColumn={false}
                    isEditable={false}
                    delete={false}
                    isRowClass={"property-normal-row"}
                    view={true}
                    viewAllPage={true}
                    redirectBaseUrl={CONSTANTS.MODULE_USERS}
                    isTitle={<div className="float-left ml-1">
                      <div className="box-circle"><p className="box-circle-text"> 1 </p></div>
                      <div className="ml-4"><p className="sidebar-main-title font-weight-bold ml-2">{t(CONSTANTS.MODULE_USERS)}</p></div>
                    </div>}
                  />
                </div>
              </div>
            </div>
        }
      </Translation>
    );
  }
}
